import React from 'react';
import './TimelineSection.css';

function TimelineSection({ formData, onChange }) {
  const handleBirthDeathChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  const handleEventChange = (index, field, value) => {
    const updatedEvents = [...(formData.events || [])];
    updatedEvents[index] = { ...updatedEvents[index], [field]: value };
    onChange({ ...formData, events: updatedEvents });
  };

  const addEvent = () => {
    const updatedEvents = [...(formData.events || []), { name: '', date: '', place: '', comment: '' }];
    onChange({ ...formData, events: updatedEvents });
  };

  const deleteEvent = (index) => {
    const updatedEvents = (formData.events || []).filter((_, i) => i !== index);
    onChange({ ...formData, events: updatedEvents });
  };

  return (
    <div className="timeline-section">
      <div className="timeline-table">
        {/* Header Row */}
        <div className="timeline-header">
          <div className="timeline-col-name">Event</div>
          <div className="timeline-col-date">Date</div>
          <div className="timeline-col-place">Place</div>
          <div className="timeline-col-comment">Comment</div>
          <div className="timeline-col-actions"></div>
        </div>

        {/* Birth Row (fixed) */}
        <div className="timeline-row timeline-row-fixed">
          <div className="timeline-col-name">
            <span className="timeline-fixed-label">Birth</span>
          </div>
          <div className="timeline-col-date">
            <input
              type="date"
              value={formData.date_of_birth || ''}
              onChange={(e) => handleBirthDeathChange('date_of_birth', e.target.value)}
              placeholder="YYYY-MM-DD"
            />
          </div>
          <div className="timeline-col-place">
            <input
              type="text"
              value={formData.place_of_birth || ''}
              onChange={(e) => handleBirthDeathChange('place_of_birth', e.target.value)}
              placeholder="Location"
            />
          </div>
          <div className="timeline-col-comment">
            <input
              type="text"
              disabled
              placeholder=""
            />
          </div>
          <div className="timeline-col-actions"></div>
        </div>

        {/* Death Row (fixed) */}
        <div className="timeline-row timeline-row-fixed">
          <div className="timeline-col-name">
            <span className="timeline-fixed-label">Death</span>
          </div>
          <div className="timeline-col-date">
            <input
              type="date"
              value={formData.date_of_death || ''}
              onChange={(e) => handleBirthDeathChange('date_of_death', e.target.value)}
              placeholder="YYYY-MM-DD"
            />
          </div>
          <div className="timeline-col-place">
            <input
              type="text"
              value={formData.place_of_death || ''}
              onChange={(e) => handleBirthDeathChange('place_of_death', e.target.value)}
              placeholder="Location"
            />
          </div>
          <div className="timeline-col-comment">
            <input
              type="text"
              disabled
              placeholder=""
            />
          </div>
          <div className="timeline-col-actions"></div>
        </div>

        {/* Custom Events */}
        {(formData.events || []).map((event, index) => (
          <div key={index} className="timeline-row timeline-row-custom">
            <div className="timeline-col-name">
              <input
                type="text"
                value={event.name || ''}
                onChange={(e) => handleEventChange(index, 'name', e.target.value)}
                placeholder="Event name"
              />
            </div>
            <div className="timeline-col-date">
              <input
                type="date"
                value={event.date || ''}
                onChange={(e) => handleEventChange(index, 'date', e.target.value)}
                placeholder="YYYY-MM-DD"
              />
            </div>
            <div className="timeline-col-place">
              <input
                type="text"
                value={event.place || ''}
                onChange={(e) => handleEventChange(index, 'place', e.target.value)}
                placeholder="Location"
              />
            </div>
            <div className="timeline-col-comment">
              <input
                type="text"
                value={event.comment || ''}
                onChange={(e) => handleEventChange(index, 'comment', e.target.value)}
                placeholder="Notes"
              />
            </div>
            <div className="timeline-col-actions">
              <button
                type="button"
                className="timeline-delete-btn"
                onClick={() => deleteEvent(index)}
                title="Delete event"
              >
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Add Event Button */}
      <button type="button" className="timeline-add-btn" onClick={addEvent}>
        + Add event
      </button>
    </div>
  );
}

export default TimelineSection;
